import { MinusIcon, AddIcon } from '@chakra-ui/icons';

export const FaqAccordionIcon = ({ isExpanded }) =>
  isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />;
